import * as React from "react";
import { observer } from "mobx-react";
import {IWindow} from "../index";

@observer
export class HasPermission extends React.Component<any, {module: string, permission: string|null, children: any}> {
    render() {
        const IWindow: IWindow = (window as IWindow);
        const { module, permission, children } = this.props;

        if (IWindow.initialState.user.level === 'superadmin' && !IWindow.initialState.user.role_id) {
            return children;
        }

        if (IWindow.initialState.permissions[module] && !permission) {
            return children;
        }

        if (IWindow.initialState.permissions[module] && permission
            && IWindow.initialState.permissions[module].includes(permission)) {
            return children;
        }

        if (IWindow.initialState.user.is_admin) {
            return children;
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./resources/js/components/HasPermission.tsx